import { create } from 'zustand';
import axiosInstance from '../api/axiosInstance';
import useAuthStore from './useAuthStore';

interface MessageState {
  userMessages: any[];
  request: number;
  loading: boolean;
  error: string | null;
  getMessages: (user1: number, user2: number,page:number) => Promise<any[]>;
  getRequest: (user1: number, user2: number) => Promise<any[]>;
 resetUserMessages: () => void;
}

export const useMessageStore = create<MessageState>((set) => ({
  userMessages: [],
  request: 0,
  loading: false,
  error: null,

  getMessages: async (user1, user2, page = 1, limit = 20) => {
    set({ loading: true, error: null });

    try {
      const authStore = useAuthStore.getState();
      
      const response = await axiosInstance.post('getMessages', {
        user1: user1,
        user2: user2,
        lat:authStore.user?.lat,
        lng:authStore.user?.lang,
        page,
        limit,
      });

      if (response.status === 200 && response.data) {
        const userChat = response.data.messages;
      //  const totalPages = response.data.totalPages;
         // Append if page > 1 (optional behavior)
        if (page > 1) {
          set(state => ({
            userMessages: [...state.userMessages, ...userChat],
            loading: false,
          }));
        } else {
          set({ userMessages: userChat, loading: false });
        }
       
        return userChat;
      }
    } catch (error) {
      console.error('Error fetching messages:', error);
      set({ error: 'Failed to fetch messages', loading: false });
    }

    return [];
  },
  getRequest: async (user1, user2) => {
    set({ loading: true, error: null });

    try {
   
      
      const response = await axiosInstance.post('getRequest', {
        user1: user1,
        user2: user2,
      });

      if (response.status === 200 && response.data) {
        const request = response.data.matchedCount;
        set({ request: request});
        return request;
      }
    } catch (error) {
      console.error('Error fetching request:', error);
      set({ error: 'Failed to fetch request' });
    }

    return [];
  },
  resetUserMessages: () => {
    set({ userMessages: [] });
    
  }
}));
